const apiVersion = '1.3';

export default {
  type: 'prod',
  appVersion: `${apiVersion}.14`,
  baseUrl: 'https://orthoca.umbi.be',
  api: `https://auth.umbi.be/v${apiVersion}/`,
  bookingApi: `https://booking.umbi.be/v${apiVersion}/`,
  communicationApi: 'https://gateway.umbi.be/communication/',
  gateway: 'https://gateway.umbi.be/',
  paymentApi: `https://payment.umbi.be/v${apiVersion}/`,
  websocketApi: 'https://booking.umbi.be/',
  reCaptchaKey: '6LcA0aUUAAAAAA4mvhI10n6VByHCzbCRcia15ngK',
  ymId: 51162704,
  GAId: 'UA-143770188-3',
  selectThemes: [
    { reg: /orthoca.umbi.be/, name: 'orthoca' }
  ],
  get appParams() {
    if (window.location.href.match(/orthoca.umbi.be/)) {
      return {
        name: 'Orthoca',
        supportLink: 'mailto:ortho-spm@azmonica.be'
      };
    } else {
      return {
        name: 'AZ Monica',
        supportLink: 'https://azmonica.be/nl/over_az_monica/contact.asp'
      };
    }
  }
};
